import Repository from '../axios'
import {
  defaultPagination
} from "@/constants/config";
const resource = "/admin/system_setting";

export default {
  getPdfTemplateList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`${resource}/pdf-templates?paginate=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getTemplateData(id) {
    return Repository.get(`${resource}/pdf-templates/${id}`)
  },
  updateTemplate(id, payload) {
    return Repository.put(`${resource}/pdf-templates/${id}`, payload)
  },
  generatePdf(payload) {
    return Repository.post(`${resource}/pdf-generate`, payload)
  }
};
